export const TRACKER_NEW_FEATURES_BANNER_OPEN = '[New Features Alert] banner open';
export const TRACKER_NEW_FEATURES_BANNER_CLOSE_CLICK = '[New Features Alert] banner close click';
export const TRACKER_NEW_FEATURES_BANNER_CLOSE = '[New Features Alert] banner close';
export const TRACKER_NEW_FEATURES_BANNER_VIEW_CHANGES_CLICK = '[New Features Alert] view changes click';
